/*
 * Floretta site-wide touches, loaded from layout/theme.liquid.
 *
 * Page transitions: floretta-overrides.css turns on cross-document view transitions (pages
 * fade into each other in browsers that support it). When a product card is clicked, its photo
 * is named here so it grows into the product page's main photo, which the stylesheet names
 * the same way.
 */
(() => {
  const handleOf = (url) => {
    const match = new URL(url, location.href).pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  addEventListener("pageswap", (event) => {
    if (!event.viewTransition || !event.activation?.entry?.url) return;
    if (handleOf(location.href)) return;
    const target = handleOf(event.activation.entry.url);
    if (!target) return;

    for (const card of document.querySelectorAll("[data-product-url]")) {
      if (handleOf(card.dataset.productUrl) !== target) continue;
      const image = card.querySelector(".product-card__featured-image");
      if (!image) return;
      image.style.viewTransitionName = "floretta-product";
      event.viewTransition.finished.finally(() => {
        image.style.viewTransitionName = "";
      });
      return;
    }
  });
})();
